/**
 * Legal content for 22 Questions
 * All legal text in one place for easy editing
 */

export const LEGAL = {
  companyName: '22 Questions',
  supportEmail: 'steve@22questions.com',
  effectiveDate: 'January 2026',

  privacyPolicy: `
<h2>Privacy Policy</h2>
<p class="legal-effective">Effective: January 2026</p>

<h3>1. Information We Collect</h3>
<p>We collect information you provide directly, including:</p>
<ul>
  <li>Account information (email address, phone number)</li>
  <li>Profile information (name, photos, bio, preferences)</li>
  <li>Messages and communications with other users</li>
  <li>Usage data and interaction history</li>
</ul>

<h3>2. How We Use Your Information</h3>
<p>We use your information to:</p>
<ul>
  <li>Provide and improve our services</li>
  <li>Match you with other users based on your preferences</li>
  <li>Send service-related communications</li>
  <li>Ensure safety and prevent fraud</li>
</ul>

<h3>3. Information Sharing</h3>
<p>We do not sell your personal information. We may share information:</p>
<ul>
  <li>With other users as part of the service (profile info, messages)</li>
  <li>With service providers who assist our operations</li>
  <li>When required by law or to protect rights and safety</li>
</ul>

<h3>4. Data Retention</h3>
<p>We retain your information while your account is active. You can delete your account and all associated data at any time from the Settings page.</p>

<h3>5. Your Rights</h3>
<p>You have the right to:</p>
<ul>
  <li>Access your personal data</li>
  <li>Correct inaccurate data</li>
  <li>Delete your account and data</li>
  <li>Export your data</li>
</ul>

<h3>6. Security</h3>
<p>We implement industry-standard security measures to protect your information, including encryption in transit and at rest.</p>

<h3>7. Contact</h3>
<p>For privacy questions, contact us at <a href="mailto:steve@22questions.com">steve@22questions.com</a></p>
  `,

  termsOfService: `
<h2>Terms of Service</h2>
<p class="legal-effective">Effective: January 2026</p>

<h3>1. Acceptance of Terms</h3>
<p>By using 22 Questions, you agree to these terms. If you do not agree, do not use the service.</p>

<h3>2. Eligibility</h3>
<ul>
  <li>You must be at least 18 years old</li>
  <li>You must provide accurate information</li>
  <li>You may only have one account</li>
</ul>

<h3>3. Acceptable Use</h3>
<p>You agree not to:</p>
<ul>
  <li>Harass, threaten, or abuse other users</li>
  <li>Post illegal, harmful, or offensive content</li>
  <li>Impersonate others or create fake profiles</li>
  <li>Use the service for commercial purposes</li>
  <li>Attempt to hack or disrupt the service</li>
  <li>Scrape data or use automated systems</li>
</ul>

<h3>4. Content Ownership</h3>
<p>You retain ownership of content you post. By posting, you grant us a license to use, display, and distribute your content as part of the service.</p>

<h3>5. Account Termination</h3>
<p>We may suspend or terminate accounts that violate these terms. You may delete your account at any time from Settings.</p>

<h3>6. Disclaimer</h3>
<p>The service is provided "as is" without warranties. We do not guarantee matches, connections, or outcomes. Users are responsible for their own safety when meeting others.</p>

<h3>7. Limitation of Liability</h3>
<p>To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages.</p>

<h3>8. Disputes</h3>
<p>Any disputes will be resolved through binding arbitration, except where prohibited by law.</p>

<h3>9. Changes</h3>
<p>We may update these terms. Continued use after changes constitutes acceptance.</p>

<h3>10. Contact</h3>
<p>Questions? Contact us at <a href="mailto:steve@22questions.com">steve@22questions.com</a></p>
  `,
};
